module.exports = __webpack_public_path__ + "assets/logo_v2-34dea8.png";